new Date().getFullYear()

if (document.getElementById("year")) {
    document.getElementById("year").innerHTML = new Date().getFullYear();
}
